/* Zenara Motion — Sophie's Skin port of the Arcline entrance-animation system.
   Lenis momentum scroll + scroll-scrubbed reveals (CSS var --si, 0 -> 1).
   Namespaced zn-* so nothing collides with Sophie's own classes.
   Replaces AOS on every element it tags: data-aos attributes are stripped
   before AOS (bundled in vendor.js) can read them, and zenara-motion.css
   carries override rules as a second line of defense.
   Load order: lenis.js (defer) -> zenara-motion.js (defer), AFTER Sophie's
   vendor.js / theme.js. Everything transform/opacity only, reduced-motion safe. */
(function () {
  'use strict';
  if (window.__znMotion) return;
  window.__znMotion = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var raf = window.requestAnimationFrame.bind(window);

  /* =========================================================
     1) SMOOTH SCROLL — Lenis (momentum/inertia). Native fallback if unavailable. */
  var lenis = null;
  if (!reduce && typeof window.Lenis === 'function') {
    lenis = new window.Lenis({
      lerp: 0.09,            // lower = smoother glide
      wheelMultiplier: 1,
      smoothWheel: true,
      touchMultiplier: 1.6
    });
    (function loop(time) { lenis.raf(time); raf(loop); })();
    lenis.on('scroll', function () { document.dispatchEvent(new CustomEvent('arc:scroll')); });
    // anchor links glide via Lenis
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a || a.getAttribute('href').length < 2) return;
      var el = null;
      try { el = document.querySelector(a.getAttribute('href')); } catch (err) { /* invalid selector (e.g. "#") */ }
      if (!el) return;
      e.preventDefault();
      lenis.scrollTo(el, { offset: -80, duration: 1.1 });
    });
  } else {
    window.addEventListener('scroll', function () { document.dispatchEvent(new CustomEvent('arc:scroll')); }, { passive: true });
  }

  /* =========================================================
     2) SOFT REVEALS — auto-tag Sophie's section content, scrub --si on scroll.
     Selectors below are Sophie's REAL classes (verified in sections/ + snippets/). */

  var R = 'zn-reveal';
  var VARIANTS = [R, 'zn-reveal--left', 'zn-reveal--right', 'zn-reveal--zoom', 'zn-reveal--tilt', 'zn-reveal--tilt-r'];

  // Everything that gets a base rise-in reveal.
  var autoSel = [
    // section headings — snippets/section-heading.liquid (.subtop, .section-title-1/-2)
    '.subtop', '.section-title-1', '.section-title-2', '.section-des',
    // product cards — snippets/product-card.liquid ("product-card js-product-card ...")
    '.product-card',
    // collection tiles — snippets/collection-grid-item.liquid (.collection-card-1),
    // snippets/collection-list-item.liquid (.collection-card),
    // sections/featured-collections-1.liquid (.collectionlist-item)
    '.collection-card-1', '.collection-card', '.collectionlist-item',
    // image-with-text media/text — sections/image-content*.liquid
    '.image-content__image-container', '.image-content__text', '.image-content-6',
    // advanced-content blocks — sections/advanced-content.liquid
    '.grid__item-inner',
    // slideshow text block — sections/slideshow-1/2/3.liquid
    '.slideshow__text-content',
    // banners — sections/grid-banner.liquid (.banner-theme), sections/parallax-banner.liquid
    '.banner-theme', '.parallax-banner__meta',
    // blog / article cards — snippets/blog-grid-1.liquid, sections/featured-articles.liquid
    '.blog__item', '.bloglist-item',
    // services + instagram tiles — sections/service.liquid, sections/instagram-customize.liquid
    '.services-item', '.instagramoff-item',
    // newsletter — sections/newsletter.liquid (.left_newlleters is the theme's own spelling)
    '.mail-section', '.left_newlleters',
    // footer columns — sections/footer.liquid
    '.site-footer__section'
  ].join(', ');

  // Side-by-side media/text: slide in from their own side (measured, not guessed).
  var sideSel = '.image-content__image-container, .image-content-6, .image-content__text';
  // Cards get the tilt-and-straighten signature, alternating direction.
  var tiltSel = '.product-card, .collection-card-1, .collectionlist-item, .instagramoff-item';
  // Stagger groups: Sophie is Bootstrap-grid based, so .row covers nearly every grid/slider.
  var groupSel = '.row, .instagram, .tab-content';

  var els = [];
  var stagger = new WeakMap();

  // Neutralize AOS on an element we own: itself, its subtree, and its ancestors
  // up to the section root (Sophie puts data-aos on section wrappers too).
  function stripAOS(el) {
    var nodes = [el].concat([].slice.call(el.querySelectorAll('[data-aos]')));
    var stop = el.closest('.shopify-section') || document.body;
    var p = el.parentElement;
    while (p) { nodes.push(p); if (p === stop) break; p = p.parentElement; }
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      if (!n || !n.removeAttribute) continue;
      n.removeAttribute('data-aos');
      n.removeAttribute('data-aos-delay');
      n.removeAttribute('data-aos-duration');
      n.removeAttribute('data-aos-easing');
      n.removeAttribute('data-aos-offset');
      n.removeAttribute('data-aos-once');
      n.removeAttribute('data-aos-anchor');
      n.removeAttribute('data-aos-anchor-placement');
      if (n.classList) { n.classList.remove('aos-init'); n.classList.remove('aos-animate'); }
    }
  }

  function tag(scope) {
    scope = scope || document;

    scope.querySelectorAll(autoSel).forEach(function (el) {
      if (!el.classList.contains(R)) el.classList.add(R);
    });

    // directional variety: pick left/right from the element's actual on-screen side
    var mid = window.innerWidth / 2;
    scope.querySelectorAll(sideSel).forEach(function (el) {
      if (el.classList.contains('zn-reveal--left') || el.classList.contains('zn-reveal--right')) return;
      var r = el.getBoundingClientRect();
      if (!r.width || r.width >= window.innerWidth * 0.9) return; // full-width: keep vertical rise
      el.classList.add((r.left + r.width / 2) <= mid ? 'zn-reveal--left' : 'zn-reveal--right');
    });

    // tilt-and-straighten on cards, alternating direction
    scope.querySelectorAll(tiltSel).forEach(function (el, i) {
      if (el.classList.contains('zn-reveal--tilt') || el.classList.contains('zn-reveal--tilt-r')) return;
      el.classList.add(i % 2 ? 'zn-reveal--tilt-r' : 'zn-reveal--tilt');
    });

    // de-dupe nested reveals — outermost wins, so motion never compounds
    scope.querySelectorAll('.' + R).forEach(function (el) {
      if (el.parentElement && el.parentElement.closest('.' + R)) {
        VARIANTS.forEach(function (c) { el.classList.remove(c); });
      }
    });

    // AOS must not double-animate anything we now own
    scope.querySelectorAll('.' + R).forEach(stripAOS);

    // per-element stagger offset (cascades siblings by index)
    scope.querySelectorAll(groupSel).forEach(function (group) {
      [].slice.call(group.children).forEach(function (child, i) {
        var t = child.classList && child.classList.contains(R) ? child : child.querySelector('.' + R);
        if (t) stagger.set(t, Math.min(i, 5) * 0.07);
      });
    });

    els = [].slice.call(document.querySelectorAll('.' + R));
    if (reduce) els.forEach(function (el) { el.style.setProperty('--si', 1); });
  }

  tag(document);
  document.documentElement.classList.add('zn-motion-ready');

  if (!reduce) {
    var vh = window.innerHeight;
    var clamp = function (n, a, b) { return Math.max(a, Math.min(b, n)); };
    // CONTINUOUS scrub: --si goes 0 -> 1 as each element rises through the viewport.
    var update = function () {
      for (var i = 0; i < els.length; i++) {
        var el = els[i], rect = el.getBoundingClientRect();
        if (rect.top > vh + 60 || rect.bottom < -60) continue;   // out of view: keep last value
        var st = stagger.get(el) || 0;
        var p = clamp((vh - rect.top) / (vh * 0.62) - st, 0, 1);  // enters at bottom, settles ~38% up
        el.style.setProperty('--si', p.toFixed(3));
      }
    };
    document.addEventListener('arc:scroll', update);
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', function () { vh = window.innerHeight; update(); }, { passive: true });
    update();
    setTimeout(update, 250);
    window.addEventListener('load', update);

    // Shopify theme editor: re-tag freshly injected section markup
    document.addEventListener('shopify:section:load', function (e) { tag(e.target || document); update(); });
  } else {
    document.addEventListener('shopify:section:load', function (e) { tag(e.target || document); });
  }
})();


/* === zn-curtain (preloader) v2 2026-09-08 ===
   Three CSS-driven phases; JS only decides WHEN they start and cleans up after.
   go     -> starts hold(560ms) + part(780ms) = 1340ms of choreography
   open   -> doors are open: release the held scroll-reveals with a transition
   cleanup-> drop every class so the --si scroll system runs frame-accurate again
   Floor 150ms so a cached load still shows the beat; hard cap 3.5s so a hanging
   asset can never trap the visitor. Skipped in the theme editor / reduced-motion. */
(function(){
  var html=document.documentElement;
  if(!html.classList.contains('zn-curtain'))return;
  var t0=performance.now(),FLOOR=750,CAP=3500,CHOREO=1340,SETTLE=900,started=false; /* v4: FLOOR 150->750 so the lockup's 680ms draw-in always completes */
  function cleanup(){html.classList.remove('zn-curtain','zn-curtain-go','zn-curtain-open');}
  function go(){
    if(started)return;started=true;
    html.classList.add('zn-curtain-go');
    setTimeout(function(){html.classList.add('zn-curtain-open');},CHOREO);
    setTimeout(cleanup,CHOREO+SETTLE);
  }
  if((window.Shopify&&Shopify.designMode)||matchMedia('(prefers-reduced-motion: reduce)').matches){cleanup();return;}
  function onLoad(){setTimeout(go,Math.max(0,FLOOR-(performance.now()-t0)));}
  if(document.readyState==='complete')onLoad();else addEventListener('load',onLoad,{once:true});
  setTimeout(go,CAP);
})();
/* === end zn-curtain === */

/* === zn-cookie 2026-10-31: Sophie's Decline saved nothing, so the banner came back on every page.
   Remember Decline in the same localStorage key Accept uses (localCookie) and keep the banner hidden. === */
(function(){
  var KEY='localCookie',html=document.documentElement;
  try{if(localStorage.getItem(KEY))html.classList.add('zn-cookie-done');}catch(e){}
  document.addEventListener('click',function(e){
    if(!e.target.closest)return;
    if(e.target.closest('.js-cookie-policy .js-btn-decline')){
      try{localStorage.setItem(KEY,'decline');}catch(err){}
      html.classList.add('zn-cookie-done');
    }
  },true);
})();
/* === end zn-cookie === */
